<template>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="组装件" name="first">
            <swb-asmbl-acc-def-list-select :checkIds="asmblIds" :filter="asmblFilter" :checkBox="true" :needDisabled="true" ref="swb_asmbl_acc_def_list_select"></swb-asmbl-acc-def-list-select>
        </el-tab-pane>
        <el-tab-pane label="入选商品" name="second">
            <swb-adopted-device-list-select :showAccFlag="true" :showCatBrandModelFixedSpecTable="true" :checkBox="true" :showAssetDefFlag="true" :checkIds="deviceIds" :filter="deviceFilter" ref="swb_adopted_device_list_select"></swb-adopted-device-list-select>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import SwbAsmblAccDefSelect from './AsmblAccDefSelect';
    Vue.regist(SwbAsmblAccDefSelect);
    import SwbGoodsInSelect from '../retailer/GoodsInSelect'
    Vue.regist(SwbGoodsInSelect);

    export default {
        name: 'swb-mercht-devc-def-rel-mack',
        desc: '资产定义关联组装件定义管理',
        props: {
            asmblIds: {
                type: Array,
                default: null
            },
            deviceIds: {
                type: Array,
                default: null
            },
            asmblFilter: {
                type: Object,
                default: function () {

                },
            },
            deviceFilter: {
                type: Object,
                default: function () {

                },
            },

        },
        data: function () {
            return {
                activeName: "first",
            }
        },
        created: function () {

        },
        methods: {
            handleClick(tab, event) {
                this.activeName = tab.name;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let deviceResult = self.$refs.swb_adopted_device_list_select.getDlgResult() || {};
                let deviceList = [];
                if(deviceResult.type == "info") {
                    deviceList = deviceResult.data;
                }
                let asmblAccResult = self.$refs.swb_asmbl_acc_def_list_select.getDlgResult() || {};
                let asmblAccList = [];
                if(asmblAccResult.type == "info") {
                    asmblAccList = asmblAccResult.data;
                }
                if(deviceList.length <= 0 && asmblAccList.length <= 0) {
                    result.type = "warn";
                    result.message = "请选择入选商品或者组装件";
                } else {
                    let resultData = {
                        deviceList: deviceList,
                        asmblAccList: asmblAccList
                    }
                    result.data = resultData;
                    result.type = "info";
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/asmblAcc/MerchtDevcDefRelMack.vue